import { Box, Heading, Stack, SimpleGrid, Image, Link, Text, Separator } from '@chakra-ui/react';

const Acknowledgments = () => {
  const logos = [
    {
      src: '/partner_logos/scap.png',
      alt: 'Sustainable Canadian Agriculture Partnership',
      link: 'https://www.saskatchewan.ca/s-cap',
    },
    {
      src: '/partner_logos/government-of-saskatchewan-logo-vector-2022.png',
      alt: 'Government of Saskatchewan',
      link: 'https://www.saskatchewan.ca/',
    },
    {
      src: '/partner_logos/canada_government.png',
      alt: 'Government of Canada',
      link: 'https://www.canada.ca/',
    },
    {
      src: '/partner_logos/sask-wheat.jpeg',
      alt: 'Saskatchewan Wheat Development Commission',
      link: 'https://www.saskwheat.ca/',
    },
    {
      src: '/partner_logos/skcanola.jpg',
      alt: 'Saskatchewan Canola',
      link: 'https://www.saskcanola.ca/',
    },
    { src: '/partner_logos/pulse.png', alt: 'Pulse Canada', link: 'https://saskpulse.com/' },
    {
      src: '/partner_logos/wcrf.jpeg',
      alt: 'Western Grains Research Foundation',
      link: 'https://www.wgrf.ca/',
    },
    {
      src: '/partner_logos/uofs.png',
      alt: 'University of Saskatchewan',
      link: 'https://www.usask.ca/',
    },
    {
      src: '/partner_logos/agbio.png',
      alt: 'College of Agriculture and Bioresources',
      link: 'https://agbio.usask.ca/',
    },
    {
      src: '/partner_logos/drac.png',
      alt: 'Digital Research Alliance of Canada',
      link: 'https://alliancecan.ca/en',
    },
    {
      src: '/partner_logos/growingforward.png',
      alt: 'Growing Forward 2',
      link: 'https://www.saskatchewan.ca/government/news-and-media/2013/april/11/growing-forward-2-agricultural-programming-launches-in-saskatchewan',
    },
    {
      src: '/partner_logos/ct.png',
      alt: 'Croptimistic Technology Inc.',
      link: 'https://swatmaps.com/',
    },
  ];

  return (
    <Stack
      w='full'
      minHeight='content-height'
      overflow='auto'
      paddingTop={{ base: '4', md: '10' }}
      paddingBottom={{ base: '6', md: '16' }}
      paddingInline={{ base: 0, md: '8', lg: '12' }}
    >
      <Box textAlign='center'>
        <Heading as='h1' size='2xl' mb='2'>
          Acknowledgments
        </Heading>
        <Text fontSize='md' mb='6'>
          We gratefully acknowledge support from the following organizations
        </Text>
      </Box>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap='8' maxW='1200px' mx='auto'>
        {logos.map((logo, index) => (
          <Link key={index} href={logo.link} target='_blank' rel='noopener noreferrer'>
            <Box
              w='full'
              height='240px'
              display='flex'
              alignItems='center'
              justifyContent='center'
              border='1px solid'
              borderColor='gray.200'
              borderRadius='md'
              bg='white'
            >
              <Stack w='full'>
                <Box p='6' display='flex' alignItems='center' justifyContent='center' minHeight='140px'>
                  <Image
                    src={logo.src}
                    alt={logo.alt}
                    maxH='140px'
                    maxW='90%'
                    width='auto'
                    height='auto'
                    objectFit='contain'
                  />
                </Box>
                <Separator size='xs' />
                <Heading as='h3' size='md' px='4'>
                  {logo.alt}
                </Heading>
              </Stack>
            </Box>
          </Link>
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default Acknowledgments;
